import { html, LitElement, TemplateResult } from "lit";
import { customElement, property } from "lit/decorators.js";
import { style } from "./assets/loader.generated-style";

import * as LoaderConstants from "./loader.constants";

/**
 * Allow users to use animated svg loading icon.
 * @CustomElement slh-loader.
 *
 * @cssprop --slh-color-neutral-shade-00 - Primary button loader color.
 * @cssprop --slh-color-primary - Secondary and ghost button loader color.
 * @cssprop --slh-color-neutral-shade-80 - Tertiary button loader color.
 * @cssprop --slh-color-error - Negative button loader color.
 */
@customElement("slh-loader")
export default class SlhLoader extends LitElement {
  /**
   * Set width
   */
  @property({
    type: Number,
    attribute: true,
  })
  width: number = LoaderConstants.LOADER_WIDTH;

  /**
   * Set height
   */
  @property({
    type: Number,
    attribute: true,
  })
  height: number = LoaderConstants.LOADER_HEIGHT;

  /**
   * Set color
   */
  @property({
    type: String,
    attribute: true,
  })
  color: string = LoaderConstants.LOADER_COLOR;

  static styles = style;

  /**
   * @returns {string} render html template
   */
  render(): TemplateResult {
    return html`
      <svg
        width="${this.width}"
        height="${this.height}"
        viewBox="0 0 38 38"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient x1="8.042%" y1="0%" x2="65.682%" y2="23.865%" id="a">
            <stop stop-color="${this.color}" stop-opacity="0" offset="0%" />
            <stop
              stop-color="${this.color}"
              stop-opacity=".631"
              offset="63.146%"
            />
            <stop stop-color="${this.color}" offset="100%" />
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <g transform="translate(1 1)">
            <path
              d="M36 18c0-9.94-8.06-18-18-18"
              id="Oval-2"
              stroke="url(#a)"
              stroke-width="2"
            >
              <animateTransform
                attributeName="transform"
                type="rotate"
                from="0 18 18"
                to="360 18 18"
                dur="0.9s"
                repeatCount="indefinite"
              />
            </path>
            <circle fill="${this.color}" cx="36" cy="18" r="1">
              <animateTransform
                attributeName="transform"
                type="rotate"
                from="0 18 18"
                to="360 18 18"
                dur="0.9s"
                repeatCount="indefinite"
              />
            </circle>
          </g>
        </g>
      </svg>
    `;
  }
}
